export default __webpack_public_path__ + "static/media/bg-tile.79cf2f47.png";